// 商品バリエーションデータを格納するオブジェクト
let productVariantsData = {};

// grid__itemの要素からdata-variant-idを取得し、grid-product__priceにidを付与する関数
function assignPriceIds() {
  // すべてのgrid__item要素を取得
  const gridItems = document.querySelectorAll('.grid__item');

  gridItems.forEach(gridItem => {
    // data-variant-id属性の値を取得
    const variantId = gridItem.dataset.variantId;
    const productId = gridItem.dataset.productId;

    // 同じgridItem内のgrid-product__price要素を検索
    const priceElement = gridItem.querySelector('.grid-product__price');

    if (priceElement && productId) {
      // data-variant-idが存在する場合
      if (variantId) {
        priceElement.id = `price-${variantId}`;

        // メタフィールドの値を表示
        displayVariantMetafield(productId, variantId, priceElement);
      } else {
        priceElement.id = `price-product-${productId}`;

        // 商品メタフィールドのみで価格を上書き
        displayProductMetafield(productId, priceElement);
      }
    }
  });
}

// バリエーションのメタフィールドを表示する関数
function displayVariantMetafield(productId, variantId, priceElement) {
  const productDataScript = document.querySelector(`.product-variants-data[data-product-id="${productId}"]`);

  if (productDataScript) {
    try {
      const productData = JSON.parse(productDataScript.textContent);
      productVariantsData[productId] = {
        variants: productData.variants,
        product_metafields: {
          custom_price: productData.product_metafields?.custom_price || null
        }
      };
      showMetafieldValue(productId, variantId, priceElement);
    } catch (error) {
      console.error('Liquidデータの解析に失敗しました:', error);
      // フォールバック: APIから取得
      fetchProductVariantsFromAPI(productId, variantId, priceElement);
    }
  } else {
    // Liquidデータがない場合はAPIから取得
    fetchProductVariantsFromAPI(productId, variantId, priceElement);
  }
}

// 商品メタフィールドのみで価格を表示する関数（data-variant-idがない場合用）
function displayProductMetafield(productId, priceElement) {
  const productDataScript = document.querySelector(`.product-variants-data[data-product-id="${productId}"]`);

  if (productDataScript) {
    try {
      const productData = JSON.parse(productDataScript.textContent);
      const productMetafields = productData.product_metafields || {};
      showProductMetafieldValue(productId, priceElement, productMetafields);
    } catch (error) {
      console.error('Liquidデータの解析に失敗しました:', error);
      // フォールバック: APIから取得
      fetchProductMetafieldFromAPI(productId, priceElement);
    }
  } else {
    // Liquidデータがない場合はAPIから取得
    fetchProductMetafieldFromAPI(productId, priceElement);
  }
}

// 商品メタフィールドをAPIから取得（data-variant-idがない場合用）
async function fetchProductMetafieldFromAPI(productId, priceElement) {
  try {
    const response = await fetch(`/products/${productId}.js`);
    const productData = await response.json();

    const productMetafields = {
      custom_price: productData.metafields?.custom?.price || null
    };

    showProductMetafieldValue(productId, priceElement, productMetafields);

  } catch (error) {
    console.error('商品データの取得に失敗しました:', error);
  }
}

// 商品メタフィールドの値を表示（data-variant-idがない場合用）
function showProductMetafieldValue(productId, priceElement, productMetafields) {
  // 商品のメタフィールド custom.price があるかチェック
  if (productMetafields && productMetafields.custom_price) {
    // 既存の価格表示内容をすべて置き換え
    replacePriceContent(priceElement, productMetafields.custom_price, 'product_metafield', null);
  }
}

// 商品のバリエーションデータをAPIから取得（フォールバック用）
async function fetchProductVariantsFromAPI(productId, variantId, priceElement) {
  if (!productVariantsData[productId]) {
    try {
      const response = await fetch(`/products/${productId}.js`);
      const productData = await response.json();

      // バリエーションデータと商品メタフィールドを格納
      productVariantsData[productId] = {
        variants: productData.variants,
        product_metafields: {
          custom_price: productData.metafields?.custom?.price || null
        }
      };

      showMetafieldValue(productId, variantId, priceElement);

    } catch (error) {
      console.error('商品データの取得に失敗しました:', error);
    }
  } else {
    showMetafieldValue(productId, variantId, priceElement);
  }
}

// メタフィールドの値を表示
function showMetafieldValue(productId, variantId, priceElement) {
  const productData = productVariantsData[productId];

  if (!productData || !productData.variants) return;

  // 一致するバリエーションを検索
  const matchingVariant = productData.variants.find(variant => variant.id == variantId);

  if (matchingVariant) {
    let finalPrice = null;
    let priceSource = '';

    // 優先度1: バリエーションのメタフィールド custom.price_variant
    if (matchingVariant.metafields && matchingVariant.metafields.price_variant) {
      finalPrice = matchingVariant.metafields.price_variant;
      priceSource = 'variant_metafield';
    }
    else if (matchingVariant.metafields && matchingVariant.metafields.custom && matchingVariant.metafields.custom.price_variant) {
      finalPrice = matchingVariant.metafields.custom.price_variant;
      priceSource = 'variant_metafield';
    }
    // 優先度2: 商品のメタフィールド custom.price
    else if (productData.product_metafields && productData.product_metafields.custom_price) {
      finalPrice = productData.product_metafields.custom_price;
      priceSource = 'product_metafield';
    }
    // 優先度3: 通常の商品価格（デフォルト）
    else {
      // 価格のみの表記にする場合はコメントを解除する
      // finalPrice = formatPrice(matchingVariant.price);
      // priceSource = 'default_price';
    }

    if (finalPrice) {
      // 既存の価格表示内容をすべて置き換え
      replacePriceContent(priceElement, finalPrice, priceSource, matchingVariant);
    }
  }
}

// 価格表示内容を置き換える関数
function replacePriceContent(priceElement, newPrice, priceSource, variant) {
  // 現在の価格表示をクリア
  priceElement.innerHTML = '';

  // 新しい価格表示を作成
  const priceContainer = document.createElement('div');
  priceContainer.className = 'custom-price-display';

  if (priceSource === 'default_price' && variant && variant.compare_at_price && variant.compare_at_price > variant.price) {
    // セール表示
    const originalPriceSpan = document.createElement('span');
    originalPriceSpan.className = 'grid-product__price--original';
    originalPriceSpan.textContent = formatPrice(variant.compare_at_price);

    const currentPriceSpan = document.createElement('span');
    currentPriceSpan.className = 'grid-product__price--sale';
    currentPriceSpan.textContent = newPrice;

    priceContainer.appendChild(originalPriceSpan);
    priceContainer.appendChild(currentPriceSpan);
  } else {
    // 通常価格表示
    const priceSpan = document.createElement('span');
    priceSpan.className = `custom-price custom-price--${priceSource}`;
    priceSpan.textContent = newPrice;
    priceContainer.appendChild(priceSpan);
  }

  // 価格ソースを示すデータ属性を追加
  priceContainer.setAttribute('data-price-source', priceSource);

  priceElement.appendChild(priceContainer);
}

// 価格をフォーマットする関数（Shopifyの価格形式に合わせる）
function formatPrice(priceInCents) {
  if (!priceInCents) return '';

  // セント単位を通貨単位に変換
  const price = priceInCents / 100;

  // 日本円の場合の例（設定に応じて調整してください）
  return new Intl.NumberFormat('ja-JP', {
    style: 'currency',
    currency: 'JPY',
    minimumFractionDigits: 0
  }).format(price);
}

// DOMが読み込まれた後に実行
document.addEventListener('DOMContentLoaded', assignPriceIds);

// 動的にコンテンツが追加される場合に対応するため、MutationObserverを使用
const observer = new MutationObserver(function(mutations) {
  let shouldUpdate = false;

  mutations.forEach(function(mutation) {
    // 新しいノードが追加された場合
    if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
      mutation.addedNodes.forEach(function(node) {
        // 追加されたノードがElementで、grid__itemクラスを持つ場合
        if (node.nodeType === Node.ELEMENT_NODE &&
            (node.classList.contains('grid__item') ||
             node.querySelector('.grid__item'))) {
          shouldUpdate = true;
        }
      });
    }
  });

  // 更新が必要な場合のみ関数を実行
  if (shouldUpdate) {
    assignPriceIds();
  }
});

// body要素を監視開始
observer.observe(document.body, {
  childList: true,
  subtree: true
});
